var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vSelect',{attrs:{"label":"fullName","placeholder":_vm.placeholder,"options":_vm.options,"reduce":_vm.reduce,"disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required},model:{value:(_vm.selectedObject),callback:function ($$v) {_vm.selectedObject=$$v},expression:"selectedObject"}})
}
var staticRenderFns = []

export { render, staticRenderFns }